import { Component, EventEmitter, Inject, Input, Output } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { DialogWrapper } from "src/app/shared/services/DialogWrapper";
import { ChargebeeService } from "src/app/shared/services/chargebee.service";

@Component({
  selector: 'app-dialog-upgrade',
  templateUrl: './dialog-upgrade.component.html',
  styleUrls: ['./dialog-upgrade.component.scss']
})
export class DialogUpgradeComponent extends DialogWrapper {
  @Input() showDialog!: boolean;
  @Output() showDialogChange = new EventEmitter<boolean>();

  constructor(
    public dialogRef: MatDialogRef<DialogUpgradeComponent>,
    @Inject(MAT_DIALOG_DATA) public matDialogData: {},
    private router: Router,
    private chargebeeService: ChargebeeService
  ) {
    super();
  }

  protected onClickUpgrade = () => {
    this.chargebeeService.openPortal();
    this.close();
  }
}
